<template>
  <div class="accounts-access-block">
    <check-block-text-value
      class="accounts-access-block__element"
      v-model="new_account.access.mode"
      :title="$t('accounts.access_mode')"
      :row="true"
      value_on="all"
      value_off="selected"
      :on_text="$t('accounts.all')"
      :off_text="$t('accounts.selected_only')"
    ></check-block-text-value>
    <accounts-multi-autocomplete
      v-on:selected="update_city_select"
      v-on:deleted="remove_city_from_selected"
      @filter="search_input"
      class="accounts-access-block__element"
      id="city_select"
      ref="city_id"
      :title="$t('accounts.city')"
      :invalid="city_invalid"
      :disabled="new_account.access.mode === 'all'"
      :options="cities"
      :selectedOptions="selected_cities"
      :clear="clear"
      v-on:reset="reset_clear"
      :placeholder="render_city_placeholder()"
    >
    </accounts-multi-autocomplete>
    <accounts-multi-autocomplete
      v-on:selected="update_pos_select"
      v-on:deleted="remove_pos_from_selected"
      @filter="search_pos_input"
      class="accounts-access-block__element"
      id="pos_select"
      ref="pos_id"
      :title="$t('accounts.pos')"
      :disabled="check_pos_disabled()"
      :options="poses"
      :selectedOptions="selected_poses"
      :clear="clear_pos"
      v-on:reset="reset_clear_pos"
      :placeholder="render_pos_placeholder()"
    >
    </accounts-multi-autocomplete>
  </div>
</template>

<script>
import CheckBlockTextValue from "@/components/recurringComponents/checkBlockTextValue";
import AccountsMultiAutocomplete from "@/components/components/accounts/accountsMultiAutocomplete";

export default {
  name: "accountsAccessBlock",
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
  },
  components: { CheckBlockTextValue, AccountsMultiAutocomplete },
  data() {
    return {
      clear: false,
      clear_pos: false,
      search_input: "",
      search_pos_input: "",
      poses: [],
      cities: [],
      selected_cities: [],
      selected_poses: [],
    };
  },
  created() {
    this.get_lists();
  },
  computed: {
    new_account: {
      get() {
        if (this.edit) {
          return this.$store.getters.EDIT_ACCOUNT;
        }
        return this.$store.getters.NEW_ACCOUNT;
      },
      set(value) {
        if (this.edit) {
          this.$store.dispatch("update_edit_account", value);
        } else {
          this.$store.dispatch("update_new_account", value);
        }
      },
    },
    city_invalid() {
      if (this.cities.length === 0) {
        return true;
      }

      return false;
    },
  },
  methods: {
    clear_selected() {
      this.selected_cities = [];
      this.selected_poses = [];
    },
    get_lists() {
      this.$store.dispatch("load_cities", true).then((response) => {
        const { data } = response.data;
        this.cities = data
          ? data.map((city) => {
              return {
                value: city.id,
                uuid: city.id,
                action: city.action,
                area: city.area,
                region: city.region,
                pos: city.pos,
                checked: city.checked ?? false,
                name: `${city.name}`,
              };
            })
          : [];
      });
    },
    check_pos_disabled() {
      return (
        this.new_account.access.mode === "all" ||
        this.selected_cities.length === 0 ||
        (this.poses.length === 0 && this.selected_poses.length === 0)
      );
    },
    render_city_placeholder() {
      let cities_count = this.selected_cities.length;
      if (cities_count === 0) {
        return this.$i18n.t("accounts.all_cities");
      }
      let last_digit = (cities_count + "").split("").pop();
      let count_end = "";
      switch (last_digit) {
        case "1":
          count_end = this.$i18n.t("accounts.endings_city.single");
          break;
        case "2":
        case "3":
        case "4":
          count_end = this.$i18n.t("accounts.endings_city.multiple_a");
          break;
        case "5":
        case "6":
        case "7":
        case "8":
        case "9":
        case "0":
          count_end = this.$i18n.t("accounts.endings_city.multiple_b");
          break;
      }

      if (cities_count >= 11 && cities_count < 15) {
        count_end = this.$i18n.t("accounts.endings_city.multiple_b");
      }
      return `${cities_count} ${count_end}`;
    },
    render_pos_placeholder() {
      let poses_count = this.selected_poses.length;
      if (poses_count === 0) {
        return this.$i18n.t("accounts.all_poses");
      }
      let last_digit = (poses_count + "").split("").pop();
      let count_end = "";
      switch (last_digit) {
        case "1":
          count_end = this.$i18n.t("accounts.endings_pos.single");
          break;
        case "2":
        case "3":
        case "4":
          count_end = this.$i18n.t("accounts.endings_pos.multiple_a");
          break;
        case "5":
        case "6":
        case "7":
        case "8":
        case "9":
        case "0":
          count_end = this.$i18n.t("accounts.endings_pos.multiple_b");
          break;
      }

      if (poses_count >= 11 && poses_count < 15) {
        count_end = this.$i18n.t("accounts.endings_pos.multiple_b");
      }
      return `${poses_count} ${count_end}`;
    },
    reset_clear() {
      this.clear = false;
    },
    reset_clear_pos() {
      this.clear = false;
    },
    generate_pos_list() {
      let poses = this.selected_cities
        .map((city) => {
          return city.pos;
        })
        ?.flat();
      if (this.selected_cities.length === 0 && poses.length === 0) {
        this.selected_poses = [];
        return [];
      }
      this.poses = poses
        .map((pos) => {
          return {
            city_id: this.selected_cities.find((x) => x.pos?.includes(pos))
              ?.value,
            value: pos.id,
            checked: pos.checked ?? false,
            name: pos.name,
            address: pos.address,
          };
        })
        .filter(
          (pos) => !this.selected_poses.find((item) => item.name === pos.name)
        );
    },
    update_city_select(item) {
      item.checked = true;
      this.selected_cities.push(item);
      this.cities = this.cities.filter((x) => x.value !== item.value);
      this.new_account.access.selected = this.selected_cities;
      this.generate_pos_list();
      this.update_new_account_lists();
    },
    remove_city_from_selected(item) {
      item.checked = false;
      this.selected_cities = this.selected_cities.filter(
        (x) => x.value !== item.value
      );
      this.selected_poses = this.selected_poses.filter(
        (x) => x.city_id !== item.value
      );
      this.cities.push(item);
      this.new_account.access.selected = this.selected_cities;
      this.generate_pos_list();
      this.update_new_account_lists();
    },
    update_pos_select(item) {
      item.checked = true;
      this.poses = this.poses.filter((x) => x.value !== item.value);
      this.selected_poses.push(item);
      this.update_new_account_lists();
    },
    remove_pos_from_selected(item) {
      (item.checked = false),
        (this.selected_poses = this.selected_poses.filter(
          (x) => x.value !== item.value
        ));
      this.poses.push(item);
      this.update_new_account_lists();
    },
    update_new_account_lists() {
      let defaultStructure = this.selected_cities.map((city) => {
        return {
          id: city.value,
          pos: this.selected_poses
            .filter((x) => x.city_id === city.value)
            .map((pos) => {
              return { id: pos.value };
            }),
        };
      });
      this.new_account.access.selected = defaultStructure;
    },
  },
};
</script>

<style scoped>
.accounts-access-block {
  display: flex;
  gap: 20px;
  margin-top: 32px;
  justify-content: flex-start;
  align-items: flex-end;
}

.accounts-access-block__element {
  width: 260px;
}
</style>
